import { render, staticRenderFns } from "./ModifyMemberTalkName.vue?vue&type=template&id=c4891ce0&scoped=true&"
import script from "./ModifyMemberTalkName.vue?vue&type=script&lang=js&"
export * from "./ModifyMemberTalkName.vue?vue&type=script&lang=js&"
import style0 from "./ModifyMemberTalkName.vue?vue&type=style&index=0&id=c4891ce0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4891ce0",
  null
  
)

export default component.exports